import { mix, observable, passthruLayout } from "@chorda/core";
export const Menu = (props) => {
    return {
        tag: 'aside',
        css: 'menu',
        items: props.groups
    };
};
export const MenuGroup = (props) => {
    return mix({
        layout: passthruLayout,
        templates: {
            label: {
                tag: 'p',
                css: 'menu-label',
            },
            list: {
                tag: 'ul',
                css: 'menu-list',
                defaultItem: {
                    tag: 'li'
                },
            }
        }
    }, props && {
        templates: {
            label: {
                text: props.label
            },
            list: {
                defaultItem: props.defaultItem,
                items: props.items
            }
        }
    });
};
export const MenuItem = (props) => {
    return mix({
        components: {
            content: true,
        },
        templates: {
            content: {
                tag: 'a',
                reactions: {
                    text: (v) => ({ text: v }),
                    active: (v) => ({ classes: { 'is-active': v } }),
                    link: (v) => ({ dom: { href: v } })
                }
            },
            list: {
                tag: 'ul',
            }
        }
    }, props && {
        name: props.name,
        templates: {
            content: {
                text: props.text,
                classes: {
                    'is-active': props.active
                }
            },
            list: {
                items: props.items
            }
        },
        components: {
            list: !!props.items
        },
        injections: {
            name: () => observable(props.name),
            link: () => observable(props.link),
            active: props.active$
        }
    });
};
